import clientOptions from "@/plugins/axios/client_options";

export default class AuthAPI {
  redirectToID() {
    window.location = `${clientOptions.authURL}?client_id=${
      clientOptions.clientID
    }&response_type=token&redirect_uri=${encodeURIComponent(
      clientOptions.redirectURI
    )}`;
  }
}
